import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../pages/Login.css';

const Register = () => {
  const [ad, setAd] = useState('');
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [rol, setRol] = useState('satış');
  const [mesaj, setMesaj] = useState('');
  const navigate = useNavigate();

  // 🔒 Varsayılan admin kullanıcıyı yükle (sadece 1 kez)
  useEffect(() => {
    const mevcut = JSON.parse(localStorage.getItem('kullanicilar'));
    if (!mevcut || mevcut.length === 0) {
      localStorage.setItem('kullanicilar', JSON.stringify([
        {
          id: 1,
          ad: 'Admin Kullanıcı',
          email: 'admin@moonx24.com',
          sifre: '123456',
          rol: 'admin'
        }
      ]));
    }
  }, []);

  const handleRegister = () => {
    if (!email || !sifre || !rol) {
      setMesaj('❗ Tüm alanları doldurunuz.');
      return;
    }

    const yeniKullanici = { id: Date.now(), ad, email, sifre, rol };
    const mevcutKullanicilar = JSON.parse(localStorage.getItem('kullanicilar')) || [];

    const ayniMail = mevcutKullanicilar.find((k) => k.email === email);
    if (ayniMail) {
      setMesaj('⚠️ Bu e-posta ile kayıtlı bir kullanıcı zaten var.');
      return;
    }

    localStorage.setItem('kullanicilar', JSON.stringify([...mevcutKullanicilar, yeniKullanici]));
    setMesaj('✅ Kullanıcı başarıyla oluşturuldu!');
    setTimeout(() => {
      navigate('/login');
    }, 1500);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>🆕 Yeni Kullanıcı Kaydı</h2>
        <input
          type="text"
          placeholder="Ad Soyad"
          value={ad}
          onChange={(e) => setAd(e.target.value)}
        />
        <input
          type="email"
          placeholder="E-posta"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Şifre"
          value={sifre}
          onChange={(e) => setSifre(e.target.value)}
        />
        <select value={rol} onChange={(e) => setRol(e.target.value)}>
          <option value="admin">Admin</option>
          <option value="satış">Satış</option>
          <option value="teknisyen">Teknisyen</option>
          <option value="muhasebe">Muhasebe</option>
        </select>
        <button onClick={handleRegister}>👤 Kaydı Tamamla</button>
        {mesaj && <p className="error-text">{mesaj}</p>}
      </div>
    </div>
  );
};

export default Register;
